import React, { useState } from "react";
import "./nominate-membership-modal.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import { addCommas, formattedDate } from "../../helpers/helpers";

const NominateByMembershipModal = (props) => {
  const [selected, setSelected] = useState(null);
  function handleCheck(item) {
    setSelected(item);
    props.getSelectedPot(item);
  }
  return (
    <div className="nominate-membership-modal-container">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="nominate-membership-modal-body">
        <p className="heading">
          <Icons
            iconname="chevron-left"
            variant="icon-twenty-four-px"
            clickHandler={props.handleBack}
          />
          {props.isEditMode
            ? "Which nominations would you like to edit?"
            : "Nominate by membership"}
        </p>
        <p className="description">
          {props.isEditMode
            ? "Rather than have separate nominations, you can consolidate them all in to one pot."
            : "If you prefer, you can select a specific membership here. Otherwise, we will apply your nominations for your total savings pot."}
        </p>
        <Row>
          <Col xl={3} lg={3} md={3} sm={3} xs={12}>
            <div
              className={
                selected === null || selected.totalValue
                  ? "pot-item pot-item-bg"
                  : "pot-item"
              }
            >
              <div className="most-popular">
                <div className="most-popular-text">MOST POPULAR</div>
              </div>
              <CustomCheckbox
                defaultChecked={true}
                name="pot"
                potId="default"
                variantName="custom-checkbox text-end"
                onChange={(e) => handleCheck(props.totalPotsData, e)}
              />
              <p className="pot-value-id">&nbsp;</p>
              <p className="total-value-head">Total pot</p>
              <p className="total-value">
                £{addCommas(props.totalPotsData?.totalValue.split(".")[0])}
                {""}
                <span className="subset-value">{`.${
                  props.totalPotsData?.totalValue.split(".")[1]
                }`}</span>
              </p>
            </div>
          </Col>
          <Col xl={1} lg={1} md={1} sm={1} xs={12}>
            <div className="vertical-line"></div>
            <hr className="pot-hr-line" />
          </Col>
          <Col
            xl={8}
            lg={8}
            md={8}
            sm={8}
            xs={12}
            className="pots-items-container"
          >
            {[...(props.totalPotsData?.membershipNominations || [])]
              .sort((a, b) => {
                const order = ["Active", "Deferred", "Drawdown", "Inactive"];
                return (
                  order.indexOf(a.memberShipStatus) -
                  order.indexOf(b.memberShipStatus)
                );
              })
              .map((item, index) => {
                return (
                  <Col
                    key={index}
                    className={
                      selected?.potId === item.potId
                        ? "pot-items mb-3 me-3 pot-items-bg"
                        : "pot-items mb-3 me-3"
                    }
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                  >
                    <CustomCheckbox
                      name="pot"
                      potId={index}
                      variantName="custom-checkbox text-end"
                      onChange={(e) => handleCheck(item, e)}
                    />
                    <p className="pot-value-id">{item.potId}</p>
                    <p className="pot-value-head">{item.potName}</p>
                    <p className="pot-total-value">
                      £{addCommas(item.potValue.split(".")[0])}
                      {""}
                      <span className="subset-value">{`.${
                        item.potValue.split(".")[1]
                      }`}</span>
                    </p>
                    <p className="pot-value-head-nomination">
                      {item.memberShipStatus}
                    </p>
                  </Col>
                );
              })}
          </Col>
        </Row>
        <span className="corrected-date">
          Figures correct as of{" "}
          {formattedDate(props.totalPotsData?.correctedDate)}
        </span>
        <Buttons
          name="Continue"
          className="primary mt-3"
          handleClick={props.handleContinue}
        />
      </div>
    </div>
  );
};

export default NominateByMembershipModal;
